var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-guide"},[_c('div',{staticClass:"card-guide-body"},[_c('iframe',{attrs:{"width":"100%","height":"1393","frameborder":"0","marginheight":"0","src":"https://docs.google.com/spreadsheets/d/15CHQBIKM9Yi0GTJofzCKqoRQBFjkIjM7soeX9f_osd0/edit?widget=true&headers=false"}})])])
}]

export { render, staticRenderFns }